import { createContext } from "react";
import { userParmas } from "@/facilities/model/user";

interface AuthContextType {
  user: string;
  roles: string[];
  role?: string; // '' | 'super' | 'admin' | 'user'
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  signin: (parma: userParmas, callback?: VoidFunction) => Promise<any>;
  signout: (callback: VoidFunction) => void;
}

export const AuthContext = createContext<AuthContextType>(null!);
